import styled from 'styled-components';
export const ButtonsContainer = styled.div`
	padding: 18px 16px !important;
	display: flex !important;
	flex-direction: column !important;
	gap: 0 !important;
	justify-content: center !important;
	align-items: center !important;
`;
